module.exports = __webpack_public_path__ + "static/media/slack.be7bf8b3.jpg";